const translations = {
  nav_about: "About",
  nav_services: "Services",
  nav_method: "Method",
  nav_library: "Library",
  nav_contact: "Contact",
  nav_login: "Log in",
  nav_register: "Sign up",
  nav_my_profile: "My profile",
  nav_availability: "Availability status",
  nav_processes: "My processes",
  nav_edit: "Edit information",
  nav_privacy: "Privacy policy",
  nav_logout: "Log out",
  nav_company_account: "Company account",
  nav_professional_account: "Professional account",
  hero_badge: "International Placement",
  hero_title_1: "Strategic talent selection across Europe",
  hero_title_2: "International Placement",
  hero_subtitle: "Strategic firm for international selection and placement in Europe.",
  hero_markets: "Germany · Switzerland · Netherlands · Austria · Belgium",
  hero_cta_talent: "Find talent",
  hero_cta_explore: "Explore opportunities",
  hero_social_proof: "+120 professionals placed in Europe",
};

export default translations;
